import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import { bool, func, object, string } from 'prop-types';
import React from 'react';
import spacingStyles from '../../../styles/spacing-styles.module.css';
import textStyles from '../../../styles/text-styles.module.css';
import { formatMoney } from '../../../util/currency';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { SWDialog } from '../../mui/Dialog';

const { Money } = sdkTypes;

const DiscountInfoDialog = ({ isOpen, onClose, discount, currency, intl }) => {
  const maxDiscountInSubunits = discount?.maxDiscount?.[currency];
  const maxDiscountMoney = maxDiscountInSubunits
    ? new Money(maxDiscountInSubunits, currency)
    : null;
  const formattedMaxDiscount = maxDiscountMoney ? formatMoney(intl, maxDiscountMoney) : null;
  const percentage = discount?.originalPercentage ?? discount?.percentage;

  return (
    <SWDialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: '500px !important' },
      }}
      scroll="paper"
    >
      <DialogTitle sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
        Discount Details
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'white',
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent tabIndex={-1} sx={{ paddingBlock: '32px !important' }}>
        <div className={`${textStyles.bodyTextB3} ${spacingStyles.mb8}`}>
          {percentage}% off your booking with a maximum discount of {formattedMaxDiscount}
        </div>
      </DialogContent>
    </SWDialog>
  );
};

DiscountInfoDialog.defaultProps = {
  isOpen: false,
};

DiscountInfoDialog.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  discount: object.isRequired,
  currency: string.isRequired,
  intl: object.isRequired,
};

export default DiscountInfoDialog;
